import React, { useContext, useEffect } from "react";

import Avatar from "../components/avatar";
import Layout from "../components/layout";
import { useForm } from "react-hook-form";
import { MyFormContext } from "../context/form.context";
import bandera from "../images/bandera.png";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const IndexPage = () => {
  const { form, setForm } = useContext(MyFormContext);
  const { handleSubmit, register, errors, formState } = useForm({
    mode: "onChange",
  });

  const handleInputs = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  useEffect(() => {}, [form]);

  return (
    <Layout>
      <div className="container hero-body">
        <div className="content ">
          <Avatar text="Hola soy Laura y te ayudaré a cotizar tu Póliza de Garantía de Arriendo" />
          <div className="column is-offset-3  is-6">
            <form>
              <div className="field">
                <div className="control">
                  <input
                    name="name"
                    onChange={handleInputs}
                    ref={register({
                      required: "Required",
                    })}
                    className={`input is-hovered ${errors.name &&
                      "is-danger"} has-text-centered`}
                    type="text"
                    placeholder="Nombre"
                  />
                  {errors.name && (
                    <p className="help is-danger has-text-centered">
                      El nombre es obligatorio
                    </p>
                  )}
                </div>
              </div>
              <div className="field">
                <div className="control has-icons-left">
                  <input
                    onChange={handleInputs}
                    style={{ paddingLeft: "22px" }}
                    name="phone"
                    ref={register({
                      required: "Required",
                      maxLength: 9,
                    })}
                    className={`input is-hovered ${errors.phone &&
                      "is-danger"} has-text-centered`}
                    type="number"
                    placeholder="Celular"
                  />
                  <span
                    className="icon is-left prefix"
                    style={{ marginLeft: "10px" }}
                  >
                    <img src={bandera} style={{ margin: "10px" }} /> +56
                  </span>
                  {errors.phone && (
                    <p className="help is-danger has-text-centered">
                      Ingrese un teléfono correcto
                    </p>
                  )}
                </div>
              </div>

              <div className="field">
                <div className="control">
                  <input
                    onChange={handleInputs}
                    name="email"
                    ref={register({
                      required: "Required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      },
                    })}
                    className={`input is-hovered ${errors.email &&
                      "is-danger"} has-text-centered`}
                    type="email"
                    placeholder="Email"
                  />
                  {errors.email && formState.isSubmitted && (
                    <p className="help is-danger has-text-centered">
                      Ingrese un email correcto
                    </p>
                  )}
                </div>
              </div>

              <div className="is-size-12 has-text-centered">
                <AniLink to="/step-2" cover direction="left" bg="#fec200">
                  <button
                    disabled={!formState.isValid}
                    type="submit"
                    className="button is-warning is-inverted is-outlined is-size-5"
                  >
                    SIGAMOS
                  </button>
                </AniLink>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
